import axios from "axios";
import { authConfig, checkedData, portalApiBase as base } from "./portalApi";
import { normalizeTasksResponse, TASK_PRIORITY_OPTIONS } from "../utilities/commercialTaskList";

const checked = (response) => checkedData(response, "Commercial task request failed");

export const fetchCommercialTasks = async (token, dealId) => {
    const response = await axios.get(`${base}/${dealId ? "commtasks-by-deal" : "commtasks"}`, {
        ...authConfig(token),
        ...(dealId ? { params: { dealId: String(dealId) } } : {}),
    });
    return normalizeTasksResponse(checked(response));
};

export const createCommercialTask = async ({ dealId, salesBrokerId, task, priority }, token) => {
    if (!dealId || !salesBrokerId || !task.trim() || !TASK_PRIORITY_OPTIONS.includes(priority)) {
        throw new Error("A deal, logged-in broker, task and priority are required");
    }
    return checked(
        await axios.post(
            `${base}/create-commtask`,
            {
                DealId: String(dealId),
                SalesBrokerId: String(salesBrokerId),
                ActionRequired: task.trim(),
                Priority: priority,
            },
            authConfig(token)
        )
    );
};

export const updateCommercialTask = async (id, field, value, token) => {
    if (
        !id ||
        !["Action_Required", "Assigned_Commercial_Exec", "Sales_Person", "Comm_Note", "Complete", "Priority"].includes(
            field
        )
    ) {
        throw new Error("Invalid task update");
    }
    if (
        (field === "Priority" && !TASK_PRIORITY_OPTIONS.includes(value)) ||
        (["Assigned_Commercial_Exec", "Sales_Person"].includes(field) && !value?.id) ||
        (field === "Complete" && typeof value !== "boolean")
    )
        throw new Error("Invalid task value");
    return checked(await axios.post(`${base}/update-commtask`, { id: String(id), [field]: value }, authConfig(token)));
};
